export const environment = {
	apiPath: 'https://api.stadspassen.eu/api',
	prefixes: 'localforlocal://',
	production: true,
	envName: 'beta',
};
